import { render, staticRenderFns } from "./MenuInbox.vue?vue&type=template&id=03aa4fae&scoped=true"
import script from "./MenuInbox.vue?vue&type=script&lang=js"
export * from "./MenuInbox.vue?vue&type=script&lang=js"
import style0 from "./MenuInbox.vue?vue&type=style&index=0&id=03aa4fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa4fae",
  null
  
)

export default component.exports